import { useEffect } from "react";

// The prerendered static <title> is correct on first paint, but the router's client-side
// navigation swaps components without touching document.title. This re-applies the active route's
// title on every navigation, so the tab text always matches the page you are on.
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
